export const SET_KCQ_CATEGORIES = 'SET_KCQ_CATEGORIES';
export const UPDATE_KCQ_CATEGORIES = 'UPDATE_KCQ_CATEGORIES';
export const SET_QUESTION_SETS = 'SET_QUESTION_SETS';
export const UPDATE_QUESTION_SETS = 'UPDATE_QUESTION_SETS';
export const SET_PERSONAL_QUESTION_SETS = 'SET_PERSONAL_QUESTION_SETS';
export const UPDATE_PERSONAL_QUESTION_SETS = 'UPDATE_PERSONAL_QUESTION_SETS';